document.addEventListener("DOMContentLoaded", function () {
  // Check if screen width is greater than 768px (desktop)
  if (window.innerWidth > 768) {
    document.getElementById("collapseAbout").classList.add("show");
    document
      .querySelector("#headingAbout button")
      .setAttribute("aria-expanded", "true");
  } else {
    // Ensure all accordions are collapsed by default on mobile
    document.getElementById("collapseAbout").classList.remove("show");
    document
      .querySelector("#headingAbout button")
      .setAttribute("aria-expanded", "false");
  }
});
